// @ vendor
const classnames = require('classnames');

// @ utilities
const { toFirstUppercase, toCamelCase } = require('utilities/stringHelper');
const { formatText } = require('core/i18n').i18n;

// @ constant
const { FOURTH_STEP } = require('constants/index');
const { validationsForInputs } = require('../../insuranceConstants/insuranceRequestHomeAddress');

const insuranceRequestBuildAddressItem = (immInsuranceWizardState) => {
    const immStep4 = immInsuranceWizardState.getIn(['steps', FOURTH_STEP]);

    const addressRoad = immStep4.get('road');
    const addressNumber = immStep4.get('number');
    const roadTypeName = immStep4.get('roadTypeName');
    const roadTypeNameUpper = roadTypeName ? toFirstUppercase(roadTypeName) : '';
    const numberValidation = /^S\/N$|^s\/n$|^[0-9]*$/;
    const addressNumberShow = addressNumber === 's/n' || addressNumber === 'S/N' || !addressNumber ? '' : `${addressNumber},`;
    const addressError = !addressRoad;

    let summaryAddress = formatText('insuranceRequestHome-summaryToBeDefined');
    const isAddresNumberValid = numberValidation.test(addressNumber);
    const roadTypeIsFetching = immStep4.get('isFetchingAddressTypeList');
    const population = immStep4.get('population');
    const populationTrim = population ? population.trim() : '';
    const populationMatch = validationsForInputs.population.match;
    const populationValidation = populationMatch.test(population);

    if (!addressError && addressRoad && isAddresNumberValid && !roadTypeIsFetching && populationValidation) {
        summaryAddress = `${roadTypeNameUpper} ${addressRoad}, ${addressNumberShow} ${populationTrim}`;
    }

    return {
        label: formatText('insuranceRequestHome-summaryAddress'),
        text: toCamelCase(summaryAddress),
        className: classnames({
            'insurance-request-compilation-card__text--disabled': addressError
        })
    };
}

module.exports = insuranceRequestBuildAddressItem;
